import React, { MutableRefObject, useRef } from 'react';

import DeliveryDate from '@/components/common/DeliveryDate';
import { DeliveryRefProps } from '@/components/common/DeliveryDate/types';
import { hideLoading, showLoading } from '@/components/common/Indicator/pageIndicator';
import { CartItemV2 } from '@/types/so';
import { getDeliveryDateFromCookie, getFirstDeliveryDate } from '@/utils/business';

interface Props {
  item: CartItemV2;
  children: React.ReactNode | string | React.ReactNode[];
  onShow?: () => void;
}

function ChangeDateBtn(props: Props) {
  const { item, children, onShow } = props;
  const deliveryRef: MutableRefObject<DeliveryRefProps> = useRef();
  const deliveryDateInCookie = getDeliveryDateFromCookie() || getFirstDeliveryDate();

  return (
    <DeliveryDate
      checkCartProductsIsExpire={true}
      ref={deliveryRef}
      productId={item?.product_id}
      onSelect={selectDate => {
        hideLoading();
        showLoading();
        window.location.reload();
      }}
      onShow={() => {
        onShow?.();
      }}
      initDate={deliveryDateInCookie}>
      {children}
    </DeliveryDate>
  );
}

export default ChangeDateBtn;
